<span class="avatar fw-800 level-{{levelKey || 'default'}}" [ngClass]="size">{{initials()}}</span>
